import React from 'react';
import News from './News';

const Home = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Welcome to Sparc Intranet</h1>
      <News />
    </div>
  );
};

export default Home; 